import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { customTotal } from 'composant/UI/tableau/Tableau';
import IconButton from '@mui/material/IconButton';
import { RiDeleteBin2Line, RiEyeLine } from 'react-icons/all';

const TableauPlanningExceptionnel = ({
  selectioneLigne,
  exPlannings,
  onDelete,
  onView, // Add this prop for viewing planning
}: {
  selectioneLigne: any;
  exPlannings: any[];
  onDelete: (row: any) => void;
  onView: (row: any) => void; // Add type for view function
}) => {
  const columns = [
    {
      dataField: 'name',
      text: 'Titre',
      sort: true,
    },
    {
      dataField: 'cron_start_day',
      text: 'Date de début',
      sort: true,
    },
    {
      dataField: 'cron_end_date',
      text: 'Date de fin',
      sort: true,
    },
    {
      dataField: 'actions',
      text: 'Actions',
      isDummyField: true,
      formatter: (_: any, row: any) => (
        <>
          <IconButton
            aria-label="delete"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(row);
            }}
          >
            <RiDeleteBin2Line size={24} />
          </IconButton>
          <IconButton
            aria-label="Afficher"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onView(row);
            }}
            sx={{
              '&:hover': {
                backgroundColor: '#f0af00',
                color: 'white',
              },
            }}
          >
            <RiEyeLine size={24} />
          </IconButton>
        </>
      ),
    },
  ];

  const selectRow = {
    mode: 'radio',
    clickToSelect: true,
    hideSelectAll: true,
    hideSelectColumn: true,
    style: {
      background: '#eeb214',
      color: 'black',
    },
    onSelect: (row: any) => {
      selectioneLigne(row);
    },
  };

  const paginationOptions = {
    paginationSize: 25,
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: '25',
        value: 25,
      },
      {
        text: '50',
        value: 50,
      },
      {
        text: 'All',
        value: exPlannings?.length || 0,
      },
    ],
  };

  if (!exPlannings?.length) {
    return null;
  }

  return (
    <BootstrapTable
      keyField="task_id"
      data={exPlannings}
      columns={columns}
      selectRow={selectRow}
      pagination={paginationFactory(paginationOptions)}
    />
  );
};

export default TableauPlanningExceptionnel;
